<template>
  <section>
    <div class="wrap">
      <div class="head">
        <h2 class="h2">FAQ</h2>
      </div>
      <div class="faq mt">
        <details open><summary>Can I try Adverpost before I pay?</summary><p>Yes. Contact us to start a free trial on an Android media player. Setup costs may apply depending on your screens.</p></details>
        <details><summary>What is e2v?</summary><p>e2v connects your CRM, DMS, POS or any API. Listings, stock and specials turn into screen content on their own, and come down when they sell or expire.</p></details>
        <details><summary>How do I sell ads on my screens?</summary><p>List screens on the marketplace, publicly or by invite, and set your own rates. Advertisers book, upload and pay online, and you get proof of play automatically.</p></details>
        <details><summary>Can I manage screens across lots of sites?</summary><p>Yes. Group and tag screens by site, region or category, schedule content to any group, and see every screen live from one dashboard.</p></details>
        <details><summary>What happens if a screen loses its connection?</summary><p>Content is stored on the player, so it keeps playing offline. Live View flags the screen so you know straight away.</p></details>
        <details><summary>Do I need council approval to show advertising?</summary><p>For your own content, usually not. Some councils need a development application before a screen can show third-party advertising, so check with your local council before listing screens publicly.</p></details>
      </div>
    </div>
  </section>
</template>

<script>
// Extracted from the published landing page; in-page anchors emit instead of
// navigating, because the app uses a hash router.
export default { name: "FaqSection" };
</script>
